import { on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ChangeSetsActions, ChangeSetsAsyncActions } from './change-sets.actions';
import { LocationSetsActions } from '../location-sets/location-sets.actions';
import { LocationSetTypesActions } from '../location-set-types/location-set-types.actions';
import { ConsumersActions } from '../consumer/consumers.actions';
import { MenuBaseActions } from '../base/menu-base.actions';
import {ChangeSet} from '@emm/core/models/change-set.model';
import {asyncActionState, AsyncActionState} from '@emm/core/util/async-action-state';
import {withLoadables} from '@emm/core/util/ngrx.util';

export const changeSetsFeatureKey = 'changeSets';

export interface ChangeSetsState extends EntityState<ChangeSet>, AsyncActionState {
    selectedId: number | null;
    allChangeSets: ChangeSet[];
}

export const adapter: EntityAdapter<ChangeSet> = createEntityAdapter<ChangeSet>({
    selectId: (item: ChangeSet) => item.id,
    sortComparer: null
});

export const initialState: ChangeSetsState = adapter.getInitialState({
    selectedId: null,
    allChangeSets: [],
    ...asyncActionState.initial
});

const { loadActions, successActions, errorActions } = ChangeSetsAsyncActions;

export const changeSetsReducer = withLoadables<ChangeSetsState>({
    loadActions,
    successActions,
    errorActions
})(
    initialState,

    on(MenuBaseActions.init, () => ({
        ...initialState,
    })),

    on(ChangeSetsActions.loadAllFutureChangeSets, (state: ChangeSetsState) => ({
        ...state,
        selectedId: null,
    })),

    on(ChangeSetsActions.loadAllFutureChangeSetsSuccess, (state: ChangeSetsState, { changeSets }) =>
        adapter.setAll(changeSets, {
            ...state,
            allChangeSets: [...changeSets],
        })
    ),


    on(ChangeSetsActions.loadFutureChangeSetsSuccess, (state: ChangeSetsState, { changeSets }) => {
        return adapter.setAll(changeSets, state);
    }),

    on(LocationSetsActions.select,
        LocationSetTypesActions.select,
        ConsumersActions.deleteSuccess, (state: ChangeSetsState) => {
            return adapter.setAll(state.allChangeSets, state);
        })
);
